import { useApi } from './use-api-call';
import { UserAgentDTO } from './user-agent-api';
import { UserDTO } from './user-api';


export const useSearchUserSessionApi = () => useApi<{ 
userSessions: UserSessionDTO[];
        userAgents: UserAgentDTO[];
        users: UserDTO[];
        allowEdit: boolean; 
    }>('/user-session/search-user-session');

export const useGetUserSessionApi = () => useApi<{ userSession: UserSessionDTO; allowEdit: boolean; }>('/user-session/get-user-session/{id}');

export const useSaveUserSessionApi = () => useApi<{ userSession: UserSessionDTO}>('/user-session/save-user-session');

export const useDeleteUserSessionApi = () => useApi('/user-session/delete-user-session/{id}');

export interface UserSessionDTO { 
id?:number;
userName:string;
refreshToken:string;
refreshCount:number;
refreshTokenDate:Date;
lastIP:string;
ipList:string;
ip:string;
userAgentId:number;
isDeleted:boolean;
createdAt?:Date;
}
